import React from 'react';
import { ReactComponent as GetEarlyAccessSvg } from 'src/assets/svg/home/get-early-access.svg';
import { ReactComponent as ToIdeaSvg } from 'src/assets/svg/home/to-ideas-tomorrow.svg';
import { ReactComponent as GetEarlyAccessMobileSvg } from 'src/assets/svg/home/get-early-access-mobile.svg';
import { ReactComponent as ToIdeaMobileSvg } from 'src/assets/svg/home/to-ideas-tomorrow-mobile.svg';
import IntroduceImg from 'src/assets/image/home/introduce.png';
import IntroduceMobileImg from 'src/assets/image/home/introduce-mobile.png';
import { useHistory } from 'react-router-dom';
import withLogin from 'src/hoc/login.enhance';
import { Button, Image } from 'antd';
import { isMobile } from 'react-device-detect';
import { Wrapper } from './Introduce.styled';
import Banner from './Banner';

function Introduce() {
    const history = useHistory();

    return (
        <>
            <Wrapper>
                <div className="left-introduce">
                    <div className="get-early">{isMobile ? <GetEarlyAccessMobileSvg /> : <GetEarlyAccessSvg />}</div>
                    <div className="to-idea">{isMobile ? <ToIdeaMobileSvg /> : <ToIdeaSvg />}</div>
                    <div className="earn-up fw-regular fs-supermedium">
                        Earn up to 40% APR just by locking ILA and join our IDO with great performance
                    </div>
                    <div className="list-btn">
                        <Button
                            onClick={() => {
                                history.push('/join-ido');
                            }}
                            className="fw-medium"
                        >
                            Join IDO
                        </Button>
                        <Button
                            onClick={() => {
                                history.push('/accounts?tab=wallet');
                            }}
                            className="fw-medium"
                        >
                            Stake ILA
                        </Button>
                    </div>
                    <div className="list-btn">
                        <Button
                            onClick={() => {
                                history.push('/coming-soon');
                            }}
                            className="fw-medium"
                        >
                            Trade Vested token
                        </Button>
                        <Button
                            onClick={() => {
                                history.push('/nft-analytics');
                            }}
                            className="fw-medium"
                        >
                            NFT Tools
                        </Button>
                    </div>
                    {!isMobile && <Banner />}
                </div>
                <div
                    className="right-introduce"
                    // data-aos="fade-down-left"
                    // data-aos-offset="300"
                    // data-aos-easing="ease-in-sine"
                    // data-aos-duration="500"
                >
                    <Image src={isMobile ? IntroduceMobileImg : IntroduceImg} preview={false} />
                </div>
            </Wrapper>
            {isMobile && <Banner />}
        </>
    );
}
export default withLogin(Introduce);
